import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ShopInfoEdit.css';

function ShopInfoEdit({ merchant, onSuccess }) {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        address_text: '',
        address_note: '',
        logo: '',
        address: '',
        city_id: '',
        is_closed: 0
    });
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [uploading, setUploading] = useState(false);
    const [preview, setPreview] = useState('');

    // 获取城市列表
    useEffect(() => {
        axios.get('/api/cities')
            .then(res => setCities(res.data))
            .catch(err => console.error('获取城市失败', err));
    }, []);

    const fetchMerchantInfo = async () => {
        const tg = window.Telegram.WebApp;
        try {
            const res = await axios.get('/api/merchant/info', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            const data = res.data;
            setFormData({
                name: data.name || '',
                description: data.description || '',
                address_text: data.address_text || '',
                address_note: data.address_note || '',
                logo: data.logo || '',
                address: data.address || '',
                city_id: data.city_id || '',
                is_closed: data.is_closed || 0
            });
            setPreview(data.logo || '');
        } catch (err) {
            console.error('获取商家信息失败', err);
            setMessage('加载信息失败');
        }
    };

    useEffect(() => {
        fetchMerchantInfo();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked ? 1 : 0 }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            alert('请选择图片文件');
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            alert('图片大小不能超过 5MB');
            return;
        }
        setUploading(true);
        const formDataUpload = new FormData();
        formDataUpload.append('image', file);
        try {
            const res = await axios.post('/api/upload', formDataUpload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setFormData(prev => ({ ...prev, logo: res.data.url }));
            setPreview(res.data.url);
            setMessage('Logo 上传成功');
        } catch (err) {
            setMessage('上传失败：' + (err.response?.data?.error || err.message));
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        const tg = window.Telegram.WebApp;
        const payload = {
            name: formData.name,
            description: formData.description,
            address_text: formData.address_text,
            address_note: formData.address_note,
            logo: formData.logo,
            address: formData.address,
            city_id: formData.city_id || null,
            is_closed: formData.is_closed
        };
        try {
            const response = await axios.put('/api/merchant/info', payload, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            if (response.data.success) {
                setMessage('保存成功');
                await fetchMerchantInfo();
                if (onSuccess) onSuccess();
            } else {
                setMessage('保存失败：服务器返回错误');
            }
        } catch (err) {
            console.error('保存失败:', err);
            setMessage('保存失败：' + (err.response?.data?.error || err.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="shop-info-edit-container">
            <h2>编辑店铺信息</h2>
            <form onSubmit={handleSubmit} className="shop-info-form">
                <div className="form-group">
                    <label>店铺名称</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>描述</label>
                    <textarea name="description" value={formData.description} onChange={handleChange} rows="3" />
                </div>

                <div className="form-group">
                    <label>城市</label>
                    <select name="city_id" value={formData.city_id} onChange={handleChange} required>
                        <option value="">请选择城市</option>
                        {cities.map(city => (
                            <option key={city.id} value={city.id}>{city.country} · {city.city_name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>详细地址</label>
                    <input
                        type="text"
                        name="address_text"
                        value={formData.address_text}
                        onChange={handleChange}
                        placeholder="输入详细地址"
                    />
                </div>

                <div className="form-group">
                    <label>地址备注</label>
                    <input
                        type="text"
                        name="address_note"
                        value={formData.address_note}
                        onChange={handleChange}
                        placeholder="例如：10楼 1002室"
                    />
                </div>

                <div className="form-group">
                    <label>显示地址</label>
                    <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="例如：武吉免登路88号"
                    />
                </div>

                <div className="form-group">
                    <label>Logo</label>
                    <div className="logo-upload-area">
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            disabled={uploading}
                            id="logo-upload"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="logo-upload" className="upload-button">
                            {uploading ? '上传中...' : '选择图片文件'}
                        </label>
                        <small>支持上传图片（最大 5MB），也可直接输入图片 URL</small>
                        {preview && (
                            <div className="logo-preview">
                                <img src={preview} alt="预览" />
                                <a href={preview} target="_blank" rel="noopener noreferrer">查看原图</a>
                            </div>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>Logo URL（手动输入）</label>
                    <input type="url" name="logo" value={formData.logo} onChange={handleChange} placeholder="https://..." />
                </div>

                <div className="form-group">
                    <label>
                        <input type="checkbox" name="is_closed" checked={formData.is_closed === 1} onChange={handleChange} />
                        闭店（店铺暂停营业，顾客可见但无法下单）
                    </label>
                </div>

                <button type="submit" disabled={loading} className="submit-btn">
                    {loading ? '保存中...' : '保存'}
                </button>
                {message && <p className="form-message">{message}</p>}
            </form>
        </div>
    );
}

export default ShopInfoEdit;